import React from 'react'
import { customize } from '/config'
import s from '/components/login/login.module.scss'

export const Logo = (): JSX.Element => (
  <img className={s.loginLogo} src={customize.images.logo} alt='App logo' />
)
